import * as React from "react";
const Loader = require("react-loader-spinner").default;
import { toast } from "react-toastify";
import * as Modal from "react-modal";
import hash from "../../assets/hash.png"
export default class Campaigns extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      campaigns: [],
      clients: [],
      selectedClient: window.account?.type === "client"? window.account.id : null,
      loading: false,
      modalOn: false,
      newCampaign: {
        id: null,
        title: ""
      },
    };
  }

  loadCategories = () => {
    fetch("campaigns/getAll", {
      method: "POST",
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ campaigns: data.campaigns });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };


  loadClients = () => {
    fetch("clients/getAll", {
      method: "POST",
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ clients: data.clients });
      })
      .catch((err) => {
        //toast.error(err.message);
      });
  };

  removeCampaign = (id: number, index: number) => {
    const confirmed = confirm("אתה בטוח?");
    if (!confirmed) return;
    this.setState({ loading: true });
    fetch("campaigns/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let campaigns = this.state.campaigns;
        campaigns.splice(index, 1);
        this.setState({
          loading: false,
          campaigns,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  newCampaign = () => {
    const newCampaign = this.state.newCampaign;
    newCampaign.clientId = this.state.selectedClient
    this.setState({ loading: true });
    fetch("campaigns/edit", {
      method: "POST",
      body: JSON.stringify(newCampaign),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let campaigns = this.state.campaigns;
        campaigns.unshift(data.campaign);
        this.setState({
          loading: false,
          campaigns,
          modalOn: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  componentDidMount() {
    this.loadCategories();
    if(window.account?.type === "admin") {
      this.loadClients()
    }
  }

  public render() {
    const { campaigns, clients } = this.state;
    return (
      <div id="campaigns-root">
        <Modal isOpen={this.state.modalOn} className="newCategory-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                modalOn: false,
                newCampaign: { id: null, title: "" },
              });
            }}
          ></a>
          <input
            name="title"
            type="text"
            value={this.state.newCampaign.title || ""}
            placeholder={"שם קמפיין"}
            onChange={(e: any) => {
              let newCampaign = this.state.newCampaign;
              newCampaign.title = e.target.value;
              this.setState({ newCampaign });
            }}
          />
          {window.account?.type === "admin" && <select onChange={(e: any) => {
              this.setState({ selectedClient: e.target.value });
            }}>
              <option selected disabled>בחירת לקוח</option>
            {clients.map((client:any) => {
              return <option value={client.id}>{client.name}</option>
            })}
          </select>}
          <button
            className="submit"
            onClick={() => {
              this.newCampaign();
            }}
          >
            שמירה
          </button>
        </Modal>
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <div className="buttonsHeader">
        <i className="fa fa-bars" onClick={() => {this.props.openMenu()}}></i>
        <h1><img src={hash}></img>קמפיינים</h1>

          {window.account.type === "admin" && <button
            onClick={() => {
              this.setState({
                modalOn: true,
                newCampaign: { id: null, title: "" },
              });
            }}
          >
            קמפיין חדש
          </button>}
        </div>

        <div className="board">
          {campaigns.map((campaign: any, i: number) => {
            return (
              <a href={window.account.type === "user"? `/campaigns/${campaign.id}/users/${window.account.id}` : `/campaigns/${campaign.id}`} key={i}><div className="category" >
                <i
                  onClick={() => {
                    this.removeCampaign(campaign.id, i);
                  }}
                  className="fas fa-trash"
                ></i>
                {campaign.id && <div className="logo" style={{backgroundImage: `url()`}}></div>}
                <span>
                 {campaign.title}
                </span>
              </div></a>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/campaigns/Campaigns.tsx